<div class="marv_select" 
    [class.no_margin]="this.noMargin"
    [class.disabled]="this.disabled"
    (click)="this.openListModal()"
    >
    <div class="marv_select_label">
        @if(this.iconSelect !== ''){
            <ion-icon class="marv_select_icon_prefix" [name]="this.iconSelect"></ion-icon>
        }
                
        @if(this.isRequired){
            <div class="marv_input_required">*</div>
        }

        <ion-label class="marv_select_placeholder">{{this.labelSelect}}</ion-label>
    </div>
    
    @for(itemSelected of this.getItemsSelected(); track $index){
        <marv-tag size="small" [showCloseButton]="true" [color]="itemSelected.color" (onCloseTag)="this.unselectItem(itemSelected)">{{itemSelected.label}}</marv-tag>
    }
    
    @if(this.withSpeechToText){
        @if(!this.isSearchingText){
            <ion-icon class="marv_select_prefix marv_select_icon_speech" name="mic-outline" (click)="this.speechToText($event)"></ion-icon>
        }
        @else{        
            <ion-spinner class="marv_select_prefix marv_select_speech_searching"></ion-spinner>
        }
    }
        
    <ion-select 
        [name]="this.formName" 
        [formControlName]="this.formName"        
        [multiple]="this.multiple"        
        [compareWith]="this.compareWith"
        >
        @for(item of this.items; track item.value){
            <ion-select-option [value]="item.value" >{{item.label}}</ion-select-option>  
        }
    </ion-select>
    
</div>

@if(this.errorText !== '' 
    && this.formGroupDirective.form.controls[this.formName] 
    && this.formGroupDirective.form.controls[this.formName].touched 
    && this.formGroupDirective.form.controls[this.formName].errors){
    <div class="marv_input_error">{{this.errorText}}</div>
}

@if(this.withSpeechToText){
    <marv-speech-to-text #marvSpeechToText (onDidDismiss)="this.onDismissSpeechToText($event)"/>
}

<ion-modal #modalList 
    class="marv_modal_list" 
    [class.hide]="this.hideListModal"
    [canDismiss]="this.canDismissListModal.bind(this)"
    (didDismiss)="this.onDidDismissListModal($event)" 
    >
    <ng-template> 
        @if(this.messageInfo && this.messageInfo !== ''){
            <ion-header>
                <ion-toolbar>
                    <marv-message type="info">{{this.messageInfo}}</marv-message>
                </ion-toolbar>
            </ion-header>
        }        
        <ion-content>            
            <marv-list #marvList 
                [items]="this.items" 
                [externalSource]="this.externalSource" 
                [maxItemsDisplayed]="this.maxItemsDisplayed" 
                [itemsSelected]="this.itemsSelectedCopy" 
                [multiple]="this.multiple" 
                [displayItemsColors]="this.displayItemsColors" 
                [displayItemsSelected]="this.displayItemsSelected" 
                [withSearch]="this.withSearch" 
                [searchDefault]="this.searchDefault" 
                (onSearchEnd)="this.onSearchEnd($event)" 
                (onSelectItem)="this.onSelectItem($event)"
            ></marv-list>
        </ion-content>
        <ion-footer>
            <ion-toolbar>                
                <ion-grid class="no_padding">
                    <ion-row class="ion-justify-content-around">                        
                        <ion-col size="auto">
                            <marv-button type="button" label="{{ 'VALIDATE' | translate }} ({{this.getCountItemsSelected()}})" icon="checkmark-outline" color="primary" (click)="this.validateChoices()" />
                        </ion-col>
                        <ion-col size="auto">
                            <marv-button type="button" label="{{ 'CANCEL' | translate }}" icon="close-outline" color="secondary" (click)="this.cancelChoices()" />
                        </ion-col>
                    </ion-row>
                </ion-grid>                
            </ion-toolbar>
        </ion-footer>
    </ng-template>
</ion-modal>